import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CompareHelper } from '@barthauer/abc/core';

declare var ol: any;

@Component({
    selector: 'map-tooltip',
    templateUrl: './map-tooltip.component.html',
    styleUrls: ['./map-tooltip.component.scss'],
    standalone: false
})
export class MapTooltipComponent implements OnInit {
  @ViewChild('tooltip', { static: true }) tooltip: ElementRef;

  public olmap: any;
  public popup: any;

  public layerName: string;
  public items: { category: string; text: string }[];
  private lastPosition: number[];
  private lastValues: Object;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit() {}

  initMapOverlay(olmap: any) {
    this.olmap = olmap;
    this.popup = new ol.Overlay({
      element: this.tooltip.nativeElement,
      positioning: "'top-right",
      autoPan: false,
    });

    this.olmap.addOverlay(this.popup);
  }

  hide(): void {
    if (this.popup && this.popup.getPosition()) {
      this.popup.setPosition(undefined);
    }
  }

  show(coordinate: number[], layerName: string, values: Object) {
    if (this.popup && values && layerName == this.layerName && CompareHelper.areDeepEqual(values, this.lastValues)) {
      this.popup.setPosition(coordinate);
      return;
    }

    this.layerName = null;
    this.items = [];
    this.lastValues = null;
    if (this.popup && values) {
      this.lastValues = values;
      const items = [];
      for (let v in values) {
        const text = values[v];
        if (text) {
          items.push({ category: v, text: text });
        }
      }

      if (items.length) {
        if (items.length === 1) {
          items[0] = { category: null, text: items[0].text };
        }
        this.layerName = layerName;
        this.items = items;

        this.changeDetectorRef.detectChanges();

        this.popup.setPosition(coordinate);
      } else {
        this.hide();
      }
    } else {
      this.hide();
    }
  }
}
